module.exports = __webpack_public_path__ + "img/Windfish-swipe.02d19d19.gif";